import { StructureSupportPlaces } from './structureSupportPlaces';
import { Logo } from './logo';
import { StructureAddressDto } from './structure-address.dto';

export class StructureDto {
  constructor(
    public readonly id?: number,
    public readonly idIODAS?: string,
    public readonly label?: string,
    public addresses: StructureAddressDto[] = [],
    public readonly active: boolean = true,
    public readonly SIRET?: string,
    public logo?: Logo,
    public supportPlaces: StructureSupportPlaces[] = [],
    public readonly contactEmail?: string,
    public readonly website?: string,
    public readonly presentation?: string,
    public readonly focusAreaIds: number[] = [],
    public readonly portalVisibility: boolean = true,
    public readonly legalName?: string,
  ) {}
}
